import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {CashClosingModelService} from '../../../Models/Finances/Cash-closing/cash-closing-model.service';
import {CashClosingStoreForm} from '../../../../Models/Finances/Cash-closing/cash-closing-store.model';

@Injectable({
  providedIn: 'root'
})
export class CashClosingApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: CashClosingModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los cierres de caja
   *
   */
  public getCashClosings(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getCierres', {}).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar cierre de caja
   *
   */
  public setCashClosing(params: CashClosingStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCierre', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
